<template>
  <div class="rating-content">
    <div v-click-outside="onClickOutside" class="modal-rating">
      <div class="item--title">
        <span class="item--title"> Your rate </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon
            class="item--close-icon"
            id="user--btn-icon"
            icon="times"
        /></span>
      </div>
      <div class="form--star">
        <star-rating
          v-model="rating"
          :star-size="30"
          :border-width="1"
          :show-rating="false"
          :increment="0.5"
          inactive-color="#efefef"
          :rounded-corners="true"
          :star-points="[
            23,
            2,
            14,
            17,
            0,
            19,
            10,
            34,
            7,
            50,
            23,
            43,
            38,
            50,
            36,
            34,
            46,
            19,
            31,
            17,
          ]"
        ></star-rating>
      </div>
      <div class="area-btn-rating">
        <button class="item--btn btn-rating" @click.prevent="sendRating">
          Send
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";
import StarRating from "vue-star-rating";

export default {
  components: {
    StarRating,
  },
  computed: mapState(["alert", "show"]),
  name: "IthMenuAsside",
  data: () => ({
    rating: 0,
    directives: {
      clickOutside: vClickOutside.directive,
    },
    paramsRating: {
      show: "tCGs9LT4D5",
      rating: 5,
    },

    form: { email: "" },
  }),
  methods: {
    onClickOutside(event) {
      if (event.target.className == "rating-content") {
        this.$store.commit("DISABLED_MENU");
      } //this.menuAsside != true &&
    },
    closeModal() {
      this.$store.commit("toggleForgotModal");
      this.$store.commit("DISABLED_MENU");
    },
    sendRating() {
      this.paramsRating.showId = this.show.id;
      this.paramsRating.rating = this.rating;

      this.$Parse.Cloud.run("rateShow", this.paramsRating)
        .then((res) => {
          if (res === "User not authenticated") {
            this.alert.color = "#EF3D58";
            this.alert.message = "You need to log in to rate.";
            this.$store.commit("editAlert", this.alert);
          } else {
            this.alert.color = "#94C659";
            this.alert.message = "Thank you for your rate.";
            this.$store.commit("editAlert", this.alert);
            this.$store.commit("UPDATE_RATING", res.avgRating);

            this.$emit("updateRating", res.avgRating);
          }

          this.$store.commit("DISABLED_MENU");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.rating-content {
  z-index: 99999;
  position: fixed;
  top: 0;
  background-color: rgba(44, 56, 72, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 15vh;
}
.modal-rating {
  background-color: #284060;
  height: 250px;
  width: 30vw;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 80px 90px 90px;
  row-gap: 10px;
  row-gap: 2%;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--close-icon {
  font-size: 11px;
  padding-top: 4.2px;
  padding-bottom: 3px;
}
.item--title {
  text-align: center;
  padding-top: 30px;
  font-size: 1.15em;
  font-weight: 600;
}
.form-rating,
.area-btn-rating,
.area--rrss {
  display: flex;
  flex-direction: column;
}

.area--rrss {
  min-height: 250px;
}
.area-input {
  position: relative;
}

.item--input {
  width: 100%;
  height: 40px;
  margin: 7px 0;
  background-color: #375072;
  border-radius: 15px;
  border: none;
  padding-left: 40px;
  box-sizing: border-box;
}
.item--input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}
.input--icon {
  position: absolute;
  left: 18px;
  right: 0;
  top: 18px;
  bottom: 0;
}
.item--forgot-password {
  text-align: center;
  margin: 7px 0;
  font-weight: 800;
}

.item--btn {
  margin: 7px 0;
  border: none;
  border-radius: 20px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}
.item--register {
  text-align: center;
}
.btn-rating {
  background-color: #94c659;
  font-size: 20px;
  font-weight: 600;
  height: 40px;
  width: 50%;
  margin: 10px auto;
}
.item--rating {
  cursor: pointer;
}
.form--star {
  display: flex;
  justify-content: center;
  margin: 30px;
}
@media (min-width: 1480px) {
  .modal-rating {
    height: 50vh;
    width: 20vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-rating {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-rating {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-rating {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-rating {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-rating {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-rating {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
}
</style>
